"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _Illustration = _interopRequireDefault(require("../Illustration/Illustration"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _StyleConfig = require("../utils/StyleConfig");
var _IllustratedMessageConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-concur_android.css") : void 0);
var _IllustratedMessageConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-concur_default.css") : void 0);
var _IllustratedMessageConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-concur_gateway.css") : void 0);
var _IllustratedMessageConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-concur_ios.css") : void 0);
var _IllustratedMessageSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-sap_fiori_3_dark.css") : void 0);
var _IllustratedMessageSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-sap_fiori_3_hcb.css") : void 0);
var _IllustratedMessageSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-sap_fiori_3_hcw.css") : void 0);
var _IllustratedMessageSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-sap_fiori_3.css") : void 0);
var _IllustratedMessageSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-sap_horizon_dark.css") : void 0);
var _IllustratedMessageSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-sap_horizon_hcb.css") : void 0);
var _IllustratedMessageSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-sap_horizon_hcw.css") : void 0);
var _IllustratedMessageSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage-sap_horizon.css") : void 0);
var _excluded = ["additionalContent", "additionalContentProps", "children", "classNameMap", "className", "description", "descriptionProps", "captionProps", "headline", "headlineProps", "illustrationType", "illustrationProps", "size"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _IllustratedMessageConcur_android.default,
  concur_default: _IllustratedMessageConcur_default.default,
  concur_gateway: _IllustratedMessageConcur_gateway.default,
  concur_ios: _IllustratedMessageConcur_ios.default,
  sap_fiori_3_dark: _IllustratedMessageSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _IllustratedMessageSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _IllustratedMessageSap_fiori_3_hcw.default,
  sap_fiori_3: _IllustratedMessageSap_fiori_.default,
  sap_horizon_dark: _IllustratedMessageSap_horizon_dark.default,
  sap_horizon_hcb: _IllustratedMessageSap_horizon_hcb.default,
  sap_horizon_hcw: _IllustratedMessageSap_horizon_hcw.default,
  sap_horizon: _IllustratedMessageSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-illustrated-message';

/** An **IllustratedMessage** is a recommended combination of a solution-oriented message,
 * engaging illustration, and conversational tone to better communicate an empty state
 * than just a message alone.
 *
 * An **IllustratedMessage** turns a situation (even a negative situation) into a better experience
 * for your users, while ensuring consistency. Through their human-centered approach,
 * **IllustratedMessage**s help to create a deeper connection with users by making
 * them feel understood, valued, and respected.
 *
 * To request additional illustrations, contact \#ask-core-ui. */

var IllustratedMessage = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var addChildProps = (0, _react.useContext)(_AddChildPropsContext.default);
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(IllustratedMessage, _props)) : _props;
  var additionalContent = props.additionalContent,
    additionalContentProps = props.additionalContentProps,
    children = props.children,
    classNameMap = props.classNameMap,
    className = props.className,
    description = props.description,
    descriptionProps = props.descriptionProps,
    captionProps = props.captionProps,
    headline = props.headline,
    headlineProps = props.headlineProps,
    illustrationType = props.illustrationType,
    illustrationProps = props.illustrationProps,
    size = props.size,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(classNameMap);
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--").concat(size), size !== 'md'));
  var passChildProps = function passChildProps(child, childProps) {
    if (child.displayName === 'Illustration') {
      return {
        ariaHidden: true,
        title: undefined,
        className: classnames("".concat(CSS_BLOCK, "__svg"), childProps.className)
      };
    }
    return {};
  };
  var renderIllustration = function renderIllustration() {
    if (illustrationType) {
      return /*#__PURE__*/_react.default.createElement(_Illustration.default, (0, _extends2.default)({}, illustrationProps, {
        ariaHidden: true,
        className: classnames("".concat(CSS_BLOCK, "__svg"), illustrationProps === null || illustrationProps === void 0 ? void 0 : illustrationProps.className),
        type: illustrationType
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
      value: passChildProps
    }, children);
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    ref: ref,
    className: classes
  }), renderIllustration(), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, captionProps, {
    className: classnames("".concat(CSS_BLOCK, "__caption"), captionProps === null || captionProps === void 0 ? void 0 : captionProps.className)
  }), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, headlineProps, {
    className: classnames("".concat(CSS_BLOCK, "__headline"), headlineProps === null || headlineProps === void 0 ? void 0 : headlineProps.className)
  }), headline), description && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, descriptionProps, {
    className: classnames("".concat(CSS_BLOCK, "__description"), descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.className)
  }), description)), additionalContent && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, additionalContentProps, {
    className: classnames("".concat(CSS_BLOCK, "__additional"), additionalContentProps === null || additionalContentProps === void 0 ? void 0 : additionalContentProps.className)
  }), additionalContent));
});
IllustratedMessage.displayName = 'IllustratedMessage';
IllustratedMessage.propTypes = {
  /** The headline explains the reason for the empty state, preferably in a single line.
   * Use the headline to convey the essence of your message in simple, engaging language.
   *
   * Write the headline in sentence case without an ending period (.) or other punctuation.
   * Exceptions include situations where you may want to emphasize the headline
   * with an exclamation mark (!) or question mark (?). */
  headline: _propTypes.default.node.isRequired,
  /** If there is a clear next step, include a call to action, ideally in the form of a button. */
  additionalContent: _propTypes.default.node,
  /** Additional props to spread to the additionalContent `<div>` element. */
  additionalContentProps: _propTypes.default.object,
  /** Additional props to spread to the caption `<div>` element. */
  captionProps: _propTypes.default.object,
  /** Additional classes to add to the wrapping `<div>` element. */
  className: _propTypes.default.string,
  /** **Illustration** component to render. This is the compositional method
   * of adding an illustration.  For a prop-based method, see `illustrationType`.
   */
  children: _propTypes.default.node,
  /** The description adds details and tells the user what to do next, in three sentences or less.
   * Write the description in sentence case with proper punctuation.
   * You can also set links in the description. */
  description: _propTypes.default.node,
  /** Additional props to spread to the description `<div>` element. */
  descriptionProps: _propTypes.default.object,
  /** Additional props to spread to the headline `<span>` element. */
  headlineProps: _propTypes.default.object,
  /**
   * * `"sm"` – This is the normal size for small containers, such as cards.
   * * `"md"` – This is the size for medium-sized containers, such as dialogs.
   * * `"lg"` – This is the size for large controls, such as tables and empty
   * states for an entire screen.
   */
  size: _propTypes.default.oneOf(_StyleConfig.ILLUSTRATION_SIZES),
  /** Type of illustration to render. This is the prop-based method of adding an illustration.
   * For a compositional method, see `children'.
   */
  illustrationType: _propTypes.default.oneOf(_StyleConfig.ILLUSTRATION_TYPES),
  /** Additional props to spread to the **Illustration** component. Only used
   * when using `illustrationType`.
   */
  illustrationProps: _propTypes.default.object
};
IllustratedMessage.defaultProps = {
  size: 'md'
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(IllustratedMessage);
exports.default = _default;